/* Home Journal — plays card videos only while they are visible.
   Autoplay/muted/loop attributes are set in Liquid; this component
   pauses offscreen videos to save battery and bandwidth. */

class JournalVideos extends HTMLElement {
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('video'));
    if (!this.videos.length) return;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.25,
    });
    this.videos.forEach((video) => this.observer.observe(video));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        const playing = video.play();
        if (playing) playing.catch(() => {});
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('journal-videos')) {
  customElements.define('journal-videos', JournalVideos);
}
